import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserDrivingPermitForm } from "Bands/components";
import { editUserDrivingPermit, userDrivingPermitSelectorCreator } from "Bands/state";
import { IUserDrivingPermitPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { IdCard } from "shared/assets/icons";

const { userDrivingPermit: permitCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserDrivingPermitModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const permitIdSelector = useMemo(() => userDrivingPermitSelectorCreator(id), [id]);
  const permit = useSelector(permitIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserDrivingPermitPatchData) => {
    dispatch(editUserDrivingPermit({ id, data }));
  };

  const defaultValues = useMemo(() => {
    const files: { [key: string]: { id: string; originalURL: string } } = {};

    permit?.files.forEach(({ id, source }, index) => {
      if (!source) return;

      files[`files.${index}`] = { id, originalURL: source };
    });

    // show original uploaded files as preview
    return {
      ...permit,
      files,
    };
  }, [permit]);

  return (
    <UserEntityModal
      defaultValues={defaultValues}
      title={permitCopy.edit.title}
      icon={IdCard}
      action={USER_ACTIONS.editUserDrivingPermit}
      buttons={buttons}
      successMessage={permitCopy.messages.edited}
      Component={UserDrivingPermitForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
